import { Typography } from '@euler/app/components/typography';
import { kApdmCampaignKindLabels } from '@euler/functions/apdm/campaignLabels';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ApdmPlanSettledFacts } from '@euler/model/apdm';
import { memo } from 'react';
import { View } from 'react-native';
import { aiColors, tint } from '../theme';

/**
 * What the campaign being planned has settled so far, one chip per fact:
 * the kind, then how many customers it reaches, in the header's chip row
 * beside the tool. Nothing until a step is settled; the steps themselves
 * are walked in the conversation.
 */
export const AiBuildSummary = memo(
  ({ settled }: { settled: ApdmPlanSettledFacts }) => {
    const { rpx } = useResponsiveContext();
    const chips = [
      settled.kind ? kApdmCampaignKindLabels[settled.kind] : null,
      settled.audienceCount != null
        ? `${settled.audienceCount.toLocaleString('zh-CN')} 位客户`
        : null,
    ].filter((chip): chip is string => chip != null);
    if (!chips.length) return null;
    return (
      <>
        {chips.map(chip => (
          <View
            key={chip}
            accessibilityLabel={'活动：' + chip}
            style={{
              paddingHorizontal: rpx(8),
              paddingVertical: rpx(2),
              borderRadius: rpx(10),
              backgroundColor: tint(aiColors.primary, 0.1),
            }}
          >
            <Typography.Text size={rpx(10)} color={aiColors.primary}>
              {chip}
            </Typography.Text>
          </View>
        ))}
      </>
    );
  },
);
